<template>
  <div>
    404 page not found
  </div>
</template>
